import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Notification from "components/Notification";
import SubmitButton from "components/Forms/Buttons/Submit";
import { authAction, resetPayload, LOGIN } from "store/actions/authAction";
import Translate from "helpers/Translate";

const Login = props => {
  const dispatch = useDispatch();
  const httpStatus = useSelector(state => state.auth.httpStatus);
  const loginPayload = useSelector(state => state.auth.payload);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [locale, setLocale] = useState("en");
  const [isLoading, setIsLoading] = useState(false);
  const [submit, setSubmit] = useState(null);

  // Load locale from localstorage on page load
  useEffect(() => {
    if (!locale) {
      const loadLocale = localStorage.getItem("locale") || "en";
      setLocale(loadLocale);
    } else {
      localStorage.setItem("locale", locale);
    }
  }, [locale]);

  // Show login errors
  useEffect(() => {
    setIsLoading(false);
    if (submit && httpStatus && httpStatus === 200) {
      setSubmit(false);
      if (loginPayload.user.role.name === "superadmin") {
        return props.history.push("/manage");
      }
      return props.history.push("/dashboard");
    }

    if ([400, 401, 403, 500].includes(httpStatus) && loginPayload) {
      Notification.error(loginPayload);
      dispatch(resetPayload(LOGIN));
    }
    // eslint-disable-next-line
  }, [httpStatus, loginPayload]);

  const handleSubmit = e => {
    e.preventDefault();
    setIsLoading(true);
    setSubmit(true);
    dispatch(authAction({ username, password }));
  };

  const handleLocale = e => {
    localStorage.setItem("locale", e.target.value);
    setLocale(e.target.value);
  };

  return (
    <div className="container">
      <div className="login-box-main">
        <img className="logo" src="img/logo-text-right.png" alt="EisenLens" />
        <div className="help fr">version {process.env.REACT_APP_VERSION}</div>
        <div className="login-box">
          {/* Email Address */}
          <div className="input-group">
            <label htmlFor="username">
              <Translate id="email_address" />:
            </label>
            <input
              type="email"
              className="form-input"
              id="username"
              data-testid="email"
              value={username}
              onKeyPress={e => e.which === 13 && handleSubmit(e)}
              onChange={e => setUsername(e.target.value)}
            />
          </div>
          {/* Password */}
          <div className="input-group">
            <label htmlFor="password">
              <Translate id="password" />:
            </label>
            <input
              type="password"
              className="form-input"
              id="password"
              data-testid="password"
              value={password}
              onKeyPress={e => e.which === 13 && handleSubmit(e)}
              onChange={e => setPassword(e.target.value)}
            />
          </div>

          {/* Locale */}
          <div className="input-group">
            <label htmlFor="locale">
              <Translate id="select_language" />:
            </label>
            <select
              className="form-input"
              id="locale"
              value={locale}
              onChange={handleLocale}
            >
              <option value="en">English</option>
              <option value="fr">Française</option>
            </select>
          </div>

          <SubmitButton
            handleSubmit={handleSubmit}
            className="btn btn-primary fr mt-10"
            isLoading={isLoading}
            buttonText={Translate({ id: "login" })}
            btnId="btnLogin"
          />
        </div>
      </div>
    </div>
  );
};

export default Login;
